import type React from "react";
import logo from "../../../assets/icons/logo.png";
import extension from "../../../assets/chrome/availableInChrome.png";
import { NavLink } from "react-router-dom";
import { isExtension } from "../../services/extension";

export const PageContainer: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	return (
		<div className="h-dvh flex flex-col flex-1">
			<div className="p-3 border-b flex-shrink-0 flex gap-3 items-center">
				<NavLink to="/">
					<img
						className="w-10 h-10  flex justify-center items-center"
						src={logo}
						alt="Logo"
					/>
				</NavLink>

				<NavLink to="/">
					<div>
						<h1 className="text-xl font-semibold tracking-tight">AI Checker</h1>
						<p className="text-sm text-muted-foreground">for Teachers</p>
					</div>
				</NavLink>
				{isExtension ? null : (
					<a
						href="https://chromewebstore.google.com/detail/ai-checker-for-teachers/fjefiillaobnkigebpejhefkmkdkimkl/?utm_source=web-app"
						className="flex-1 flex justify-end"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src={extension}
							alt="Chrome Extension"
							className="h-12 min-w-42 hover:scale-105 active:scale-95 transition-all duration-300"
						/>
					</a>
				)}
			</div>
			{children}
		</div>
	);
};
